import { ApplicationSubmissionsState } from './submissions.types'

export default (): ApplicationSubmissionsState => ({
  data: {},
  filters: {}
})
